import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Truncate from "react-truncate";
import "./ConcernListItem.css";
import "../../node_modules/font-awesome/css/font-awesome.min.css";
import PlusButton from "./PlusButton.js";

class ConcernListItem extends Component {
  constructor() {
    super();

    this.state = {
      currentlyEditingConcernText: false,
      currentlyEditingReporter: false,
      bumpUpArrow: false,
    };
  }

  formatConcernName = concern => {
    var formattedConcern;

    if (concern) {
      formattedConcern = concern;
      return <Truncate lines={3}>{formattedConcern}</Truncate>;
    } else {
      formattedConcern = "no concern";
      return (
        <div className="empty-text">
          <Truncate lines={3}>{formattedConcern}</Truncate>
        </div>
      );
    }
  };

  formatReporterName = reporter => {
    var name;
    if (reporter) {
      name = "by " + reporter;
      return <Truncate>{name}</Truncate>;
    } else {
      name = "no reporter";
      return (
        <div className="empty-text">
          <Truncate>{name}</Truncate>
        </div>
      );
    }
  };

  switchToEditMode = fieldName => {
    if (this.props.concern.status === "open") {
      if (fieldName === "concernText") {
        this.setState({
          currentlyEditingConcernText: true,
        });
        setTimeout(() => this.concernTextInput.focus(), 0);
      } else if (fieldName === "reporter") {
        this.setState({
          currentlyEditingReporter: true,
        });
        setTimeout(() => this.reporterInput.focus(), 0);
      }
    }
  };

  switchToReadMode = fieldName => {
    if (fieldName === "concernText") {
      this.setState({
        currentlyEditingConcernText: false,
      });
    } else if (fieldName === "reporter") {
      this.setState({
        currentlyEditingReporter: false,
      });
    }

    let concern = this.props.concern;
    window.analytics.track("Edits a Concern", {
      concernText: concern.concernText,
      reporter: concern.reporter,
      updatedFieldName: fieldName,
      plusOnesCount: concern.plusOnes,
      actionMemberId: concern.action ? concern.action.memberId : null,
      actionText: concern.action ? concern.action.actionText : null,
    });
  };

  moveCursorToInputEnd = inputRef => {
    var temp_value = inputRef.value;
    inputRef.value = "";
    inputRef.value = temp_value;
  };

  handleEditConcern = (event, fieldName) => {
    var updatedField = event.target.value;
    var index = this.props.index;
    this.props.commitEditedConcern(index, fieldName, updatedField);
  };

  renderReadOrEditConcernText = () => {
    if (this.state.currentlyEditingConcernText) {
      return (
        <form
          className="concern-text-input-only-container"
          onSubmit={event => {
            event.preventDefault();
            this.concernTextInput.blur();
          }}
        >
          <input
            className={`editable-input concern-text ${this.props.concern
              .status}`}
            value={this.props.concern.concernText}
            onChange={event => this.handleEditConcern(event, "concernText")}
            ref={input => (this.concernTextInput = input)}
            onFocus={() => this.moveCursorToInputEnd(this.concernTextInput)}
            onBlur={() => this.switchToReadMode("concernText")}
          />
          <div className="save-hint">
            Press <span className="blue">Enter</span> to save
          </div>
          <button style={{ display: "none" }} type="submit" />
        </form>
      );
    } else {
      return (
        <div
          className={`concern-text ${this.props.concern.status}`}
          onClick={() => this.switchToEditMode("concernText")}
        >
          {this.formatConcernName(this.props.concern.concernText)}
        </div>
      );
    }
  };

  renderReadOrEditReporter = () => {
    if (this.state.currentlyEditingReporter) {
      return (
        <form
          className="reporter-input-only-container"
          onSubmit={event => {
            event.preventDefault();
            this.reporterInput.blur();
          }}
        >
          <input
            className={`editable-input reporter ${this.props.concern.status}`}
            value={this.props.concern.reporter}
            onChange={event => this.handleEditConcern(event, "reporter")}
            ref={input => (this.reporterInput = input)}
            onFocus={() => this.moveCursorToInputEnd(this.reporterInput)}
            onBlur={() => this.switchToReadMode("reporter")}
          />
          <div className="save-hint">
            Press <span className="blue">Enter</span> to save
          </div>
          <button
            style={{
              display: "none",
            }}
            type="submit"
          />
        </form>
      );
    } else {
      return (
        <span
          className={`reporter ${this.props.concern.status}`}
          onClick={() => this.switchToEditMode("reporter")}
        >
          {this.formatReporterName(this.props.concern.reporter)}
        </span>
      );
    }
  };

  renderActionLabel = () => {
    var memberCopy;
    var actionLabel;
    if (this.props.concern.action && this.props.concern.action.memberId) {
      for (let member of this.props.members) {
        if (member.id === this.props.concern.action.memberId) {
          memberCopy = member;
        }
      }
    }

    if (memberCopy) {
      if (memberCopy.name) {
        actionLabel = (
          <div className="text-container">
            <span className="at-sign">@</span>
            <span className="text">{memberCopy.name}</span>
          </div>
        );
      } else if (memberCopy.email) {
        actionLabel = (
          <div className="text-container">
            <span className="at-sign">@</span>
            <span className="text">{memberCopy.email}</span>
          </div>
        );
      }
    } else if (
      this.props.concern.action &&
      this.props.concern.action.actionText
    ) {
      actionLabel = (
        <div className="text-container">
          <span className="at-sign">@</span>
          <span className="text empty-text">{"no name"}</span>
        </div>
      );
    } else {
      actionLabel = (
        <div>
          <PlusButton concern={this.props.concern} type={"action-item"} />
          <span className="text-container no-action">{"Add Owner"}</span>
        </div>
      );
    }

    return actionLabel;
  };

  handleClickCheckbox = (index, status) => {
    if (status === "open") {
      this.props.updateConcernStatus(index, "queued", status);
    } else if (status === "queued" || status === "completed") {
      this.props.updateConcernStatus(index, "open", status);
    }
  };

  handlePlusButtonClick = () => {
    if (this.props.concern.status === "open") {
      this.props.incrementPlusOnes(this.props.index);
      this.setState(
        {
          bumpUpArrow: true,
        },
        () => {
          setTimeout(() => {
            this.setState({
              bumpUpArrow: false,
            });
          }, 100); //Timing must be double the timing used for the CSS transition
        }
      );
    }
  };

  handleActionItemClick = () => {
    if (this.props.concern.status === "open") {
      this.props.openCloseActionModal(true, this.props.index);
    }
  };

  render() {
    return (
      <li className="concern-list-item">
        <div className="checkbox-container">
          <div
            className={`checkbox ${this.props.concern.status}`}
            onClick={() =>
              this.handleClickCheckbox(
                this.props.index,
                this.props.concern.status
              )}
          >
            {/* set to display:none; if parent class is "open" */}
            <span className="fa fa-check" />
          </div>
        </div>
        <div className="editable-container concern-text-container">
          {this.renderReadOrEditConcernText()}
        </div>
        <div className="editable-container reporter-container">
          {this.renderReadOrEditReporter()}
        </div>
        <div
          className={`plus-ones-container ${this.props.concern.status}`}
          onClick={this.handlePlusButtonClick}
        >
          <div>
            <div className={`up-arrow bump-${this.state.bumpUpArrow}`}>
              <span className="fas fa-long-arrow-alt-up" />
            </div>
          </div>
          <span className={`plus-ones`}>{this.props.concern.plusOnes}</span>
        </div>
        <span className={`created-at ${this.props.concern.status}`}>
          {moment(this.props.concern.createdAt).format("MMM D")}
        </span>
        <div className="action-item-container">
          <div
            className={`action-item-clickzone ${this.props.concern.status}`}
            onClick={this.handleActionItemClick}
          >
            {this.renderActionLabel()}
          </div>
        </div>
      </li>
    );
  }
}

ConcernListItem.propTypes = {
  concern: PropTypes.shape({
    id: PropTypes.number.isRequired,
    concernText: PropTypes.string,
    reporter: PropTypes.string,
    assignee: PropTypes.string,
    plusOnes: PropTypes.number.isRequired,
    createdAt: PropTypes.number.isRequired,
    status: PropTypes.oneOf(["open", "queued", "completed"]),
    userId: PropTypes.string.isRequired,
  }).isRequired,
  members: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
  updateConcernStatus: PropTypes.func.isRequired,
  commitEditedConcern: PropTypes.func,
  incrementPlusOnes: PropTypes.func,
  openCloseActionModal: PropTypes.func,
};

export default ConcernListItem;



// WEBPACK FOOTER //
// ./src/components/ConcernListItem.js